import React from 'react';
import { Button } from '@innovyze/stylovyze';
import { useDispatch } from 'react-redux';
import { deployGreengrassV2 } from '@Actions';
import { DeploymentOptions } from '@Types/implementation';
import styled from 'styled-components';

const StyledButton = styled(Button)`
	margin-right: 22px;
`;

interface DowngradeButtons {
	newApi: boolean;
	disabled: boolean;
}

export const DowngradeButtonsControls = (props: DowngradeButtons) => {
	const { disabled, newApi } = props;
	const dispatch = useDispatch();

	const onClickDowngrade = (mode: DeploymentOptions) => () => {
		dispatch(deployGreengrassV2({ newApi, deploymentOption: mode }));
	};

	return (
		<>
			<StyledButton
				data-cy="downgradeButton1"
				color="primary"
				variant="contained"
				onClick={onClickDowngrade(DeploymentOptions.DOWNGRADE_ALL)}
				disabled={disabled}>
				DOWNGRADE ALL
			</StyledButton>

			<StyledButton
				data-cy="downgradeButton1"
				color="primary"
				variant="contained"
				onClick={onClickDowngrade(DeploymentOptions.DOWNGRADE_AWS_ONLY)}
				disabled={disabled}>
				DOWNGRADE AWS ONLY
			</StyledButton>
		</>
	);
};
